import { Injectable } from "@angular/core";
import { Topics } from "@common/interfaces/topics";
import { IID_OL_CONTRATTO } from "@common/interfaces/interfaceData";
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore, StoreConfig } from "@datorama/akita";

export interface IIDolContrattoState extends EntityState<IID_OL_CONTRATTO, ID> { }

@Injectable({
  providedIn: 'root'
})
@StoreConfig({ name: Topics.IID_OL_CONTRATTO })
export class IIDolContrattoStore extends EntityStore<IIDolContrattoState> {
  constructor() {
    super([]);
  }
}
